import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

export default class Header extends Component {
  render() {
    return (
      <Row>
        <Col xs={12}>
          <Navbar bg="light" variant="light">
              <Navbar.Brand>
                <Nav.Link href="http://rivertrack.org/">RiverTrack</Nav.Link>
              </Navbar.Brand>
              <Navbar.Toggle />
              <Nav>
                <LinkContainer to="/">
                  <Nav.Link eventkey={1}>Communities</Nav.Link>
                </LinkContainer>
              </Nav>
          </Navbar>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/Header.js